import "./itens.css";
import * as React from "react";
import { useState, useEffect } from "react";
import { userRequest, generateFileUrl } from "../../requestMethods";
import { useLocation } from "react-router-dom";
import {
  formatPricing,
  formatTime24hourFormat,
  formatCpfOrCnpj,
} from "../../util/helper";
import {
  orderDiscount,
  orderNetValue,
  orderTotal,
} from "../../util/orderTotals";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import { useCompany } from "../../components/context/CompanyContext";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import PrintIcon from "@mui/icons-material/Print";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function Itens() {
  const location = useLocation();
  const orderId = location.pathname.split("/")[3];
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const { companyId, companyName, imgLogo,unitProduct } = useCompany();
  const nav = useNavigate();

  useEffect(() => {
    if (companyId > 0) getOrders();
  }, [companyId]);

  const getOrders = async () => {
    try {
      const res = await userRequest.get(`${companyId}/orders/${orderId}`);
      setData(res.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const generatePDF = async () => {
    try {
      setLoading(true);
      const res = await userRequest.get(
        `${companyId}/orders/invoice/${orderId}?sendWhatsapp=false`,
      );
      const fileUrl = res.data;
      if (fileUrl) window.open(fileUrl, "_blank");
    } catch (error) {
      console.log("error", error);
    } finally {
      setLoading(false);
    }
  };

  const getDiscount = () => orderDiscount(data);
  const getTotalOrder = () => orderTotal(data);
  const getNetValue = () => orderNetValue(data);

  function returnAddress(address) {
    if (!address) return "";
    const line1 = `${address.street || ""}, ${address.number || ""}${address.complement ? ` — ${address.complement}` : ""}`;
    const line2 = `${address.locality || ""} - ${address.postal_code || ""} — ${address.city || ""} — ${address.region_code || ""}`;

    return (
      <>
        <div>{line1}</div>
        <div>{line2}</div>
      </>
    );
  }

  const tipoDoc =
    data?.status === "Pago"
      ? "Comprovante de Pagamento"
      : "Comprovante do Pedido";

  function InfoRow({ label, value }) {
    if (!value) return null;
    return (
      <div className="itens-info-row">
        <span className="itens-info-key">{label}</span>
        <span className="itens-info-val">{value}</span>
      </div>
    );
  }

  return (
    <>
      {/* Toolbar */}
      <div className="itens-toolbar">
        <Button
          variant="outlined"
          size="small"
          startIcon={<ArrowBackIcon />}
          onClick={() => nav(-1)}
        >
          Voltar
        </Button>
        <Button
          variant="contained"
          color="secondary"
          size="small"
          startIcon={<PrintIcon />}
          disabled={loading}
          onClick={generatePDF}
        >
          {loading ? "Gerando..." : "Gerar PDF"}
        </Button>
      </div>

      <div className="itens-page">
        {/* Header */}
        <div className="itens-header">
          <div>
            {imgLogo ? (
              <img
                className="itens-header-logo"
                src={generateFileUrl(imgLogo)}
                alt={companyName}
              />
            ) : (
              <span style={{ fontSize: 18, fontWeight: 700, color: "#333" }}>
                {companyName}
              </span>
            )}
          </div>
          <div className="itens-header-right">
            <div className="itens-doc-title">{tipoDoc}</div>
            <div className="itens-doc-ref">
              Pedido #{data?.orderRef}&nbsp;·&nbsp;
              {data && formatTime24hourFormat(data.createdAt)}
            </div>
          </div>
        </div>

        {/* Info boxes */}
        <div className="itens-info-grid">
          {/* Pedido */}
          <div className="itens-info-box">
            <div className="itens-info-label">Pedido</div>
            <InfoRow
              label="Criado"
              value={data && formatTime24hourFormat(data.createdAt)}
            />
            <InfoRow
              label="Pago"
              value={data && formatTime24hourFormat(data.paymentAt)}
            />
            <InfoRow label="Pagamento" value={data?.paymentType} />
            <InfoRow label="Vendedor" value={data?.userName} />
            <InfoRow label="Representante" value={data?.userRep} />
          </div>

          {/* Empresa */}
          <div className="itens-info-box">
            <div className="itens-info-label">Empresa</div>
            <div className="itens-info-name">{companyName}</div>
          </div>

          {/* Cliente */}
          <div className="itens-info-box">
            <div className="itens-info-label">Cliente</div>
            {data?.customer && (
              <>
                <div className="itens-info-name">{data.customer.name}</div>
                {data.customer.cnpj_cpf && (
                  <div className="itens-info-val">
                    {formatCpfOrCnpj(data.customer.cnpj_cpf)}
                  </div>
                )}
                {data.customer.owner_cpf && (
                  <div className="itens-info-val">
                    {formatCpfOrCnpj(data.customer.owner_cpf)}
                  </div>
                )}
                <div
                  style={{
                    marginTop: 3,
                    fontSize: 9,
                    color: "#555",
                    lineHeight: 1.5,
                  }}
                >
                  {returnAddress(data.address)}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Observação */}
        {data?.obs && (
          <>
            <div className="itens-section-title">Observação</div>
            <div className="itens-obs-box">{data.obs}</div>
          </>
        )}

        {/* Produtos */}
        <div className="itens-section-title">Itens do Pedido</div>
        <table className="custon_table">
          <thead>
            <tr>
              <td width={80}>Foto</td>
              <td>Produto</td>
              <td>Grade</td>
            </tr>
          </thead>
          <tbody>
            {data?.products.map((product, i) => (
              <tr key={i}>
                <td>
                  <img
                    className="custom-item-img"
                    src={generateFileUrl(product.img)}
                    alt={product.title}
                  />
                </td>
                <td style={{ minWidth: 200 }}>
                  <div className="custom_product_title">{product.title}</div>
                  <div className="custom_cart_complement">
                    Ref.: {product.ref}
                  </div>
                  {product.desc && (
                    <div className="custom_cart_complement">
                      Desc.: {product.desc}
                    </div>
                  )}
                  <div className="custom_cart_complement">
                    Vlr. unitário: {formatPricing(product.price)}
                  </div>
                  <div className="custom_cart_complement">
                    Qtd.: {product.quantity} {unitProduct.unit}
                  </div>
                  <div className="custom_product_price">
                    Total: {formatPricing(product.price * product.quantity)}
                  </div>
                </td>
                <td>
                  <table className="custom-minigrid">
                    <thead>
                      <tr>
                        <td>&nbsp;</td>
                        {product.sizes.map((size) => (
                          <td key={size.ref}>{size.label}</td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {product.colors
                        .map((color, iColor) => ({ color, iColor }))
                        .filter(({ iColor }) =>
                          product.sizes.some(
                            (_, iSize) =>
                              product.colorsSizesGrid[iColor][iSize] > 0,
                          ),
                        )
                        .map(({ color, iColor }) => (
                          <tr key={color.ref}>
                            <td style={{ padding: 0, border: "none" }}>
                              <div
                                style={{
                                  backgroundColor: color.rgb,
                                  width: 28,
                                  height: 22,
                                  borderRadius: 4,
                                  margin: "0 auto",
                                }}
                              />
                              <div
                                style={{
                                  textAlign: "center",
                                  fontSize: 9,
                                  color: "#555",
                                }}
                              >
                                {color.label}
                              </div>
                            </td>
                            {product.sizes.map((size, iSize) => (
                              <td
                                key={size.ref}
                                className={
                                  !product.colorsSizesGrid[iColor][iSize]
                                    ? "custom-minigrid-no-value"
                                    : undefined
                                }
                              >
                                {product.colorsSizesGrid[iColor][iSize] ===
                                  undefined ||
                                product.colorsSizesGrid[iColor][iSize] ===
                                  null ? (
                                  <DoDisturbIcon
                                    style={{ fontSize: 14, color: "#ccc" }}
                                  />
                                ) : (
                                  product.colorsSizesGrid[iColor][iSize] || 0
                                )}
                              </td>
                            ))}
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* Totais */}
        <div className="itens-totals-wrapper">
          <table className="itens-totals-table">
            <tbody>
              <tr>
                <td className="itens-totals-lbl">{unitProduct.unitLabel}</td>
                <td className="itens-totals-val">{data?.quantity} {unitProduct.unit}</td>
              </tr>
              <tr>
                <td className="itens-totals-lbl">Subtotal</td>
                <td className="itens-totals-val">
                  {formatPricing(data?.amount || 0)}
                </td>
              </tr>
              <tr>
                <td className="itens-totals-lbl">Frete</td>
                <td className="itens-totals-val">
                  {data?.delivery?.VlTotal > 0
                    ? formatPricing(data.delivery.VlTotal)
                    : "R$ 0,00"}
                </td>
              </tr>
              {getDiscount() > 0 && (
                <tr>
                  <td className="itens-totals-lbl">Desconto</td>
                  <td className="itens-totals-val">
                    - {formatPricing(getDiscount())}
                  </td>
                </tr>
              )}
              <tr>
                <td className="itens-totals-lbl" style={{ fontWeight: 600 }}>
                  Valor Líquido
                </td>
                <td className="itens-totals-val" style={{ fontWeight: 600 }}>
                  {formatPricing(getNetValue())}
                </td>
              </tr>
              {data?.cashback > 0 && (
                <tr>
                  <td className="itens-totals-lbl">Cashback</td>
                  <td className="itens-totals-val">
                    - {formatPricing(data.cashback)}
                  </td>
                </tr>
              )}
              <tr>
                <td className="itens-totals-lbl">Total</td>
                <td className="itens-totals-val">
                  {formatPricing(getTotalOrder())}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
